import { motion } from "framer-motion"
import { useThemeSurfaces } from "../../theme/useThemeSurfaces"

export type ActionChipProps = {
  label: string
  loading: boolean
  disabled?: boolean
  onClick: () => void
}

export function ActionChip({ label, loading, disabled = false, onClick }: ActionChipProps) {
  const surfaces = useThemeSurfaces()
  const token = surfaces.button.outline

  return (
    <motion.button
      type="button"
      whileTap={{ scale: 0.95 }}
      disabled={loading || disabled}
      onClick={onClick}
      className="mono"
      style={{
        padding: "10px 16px",
        border: token.border,
        background: token.background,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        cursor: loading || disabled ? "progress" : "pointer",
        opacity: loading || disabled ? 0.6 : 1,
        minHeight: "44px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        color: token.color,
        boxShadow: token.shadow,
      }}
    >
      {loading ? "…" : label}
    </motion.button>
  )
}
